import http from 'services/http';

// The JobProcess statuses the backend serializes and broadcasts.
export type ReferralSourceImportStatus = 'pending' | 'running' | 'completed' | 'error';

export interface ReferralSourceImport {
  id: string;
  status: ReferralSourceImportStatus;
  error: string | null;
  filename: string | null;
  // Set once the import completes.
  addedCount: number | null;
  skippedCount: number;
  // Rows not imported, with the reason, e.g. already on the list or a name another source uses.
  skippedRows: SkippedReferralSourceRow[];
}

export interface SkippedReferralSourceRow {
  row: number;
  name: string;
  // The row's Also Known As names, joined with "; ".
  aliases: string;
  reason: string;
}

export interface CreateReferralSourceImportParams {
  clientId: string;
  signedId: string;
  filename: string;
}

export async function createReferralSourceImport({
  clientId,
  ...params
}: CreateReferralSourceImportParams): Promise<ReferralSourceImport> {
  return http
    .post<ReferralSourceImport>(`/admin/clients/${clientId}/referral_source_imports`, params)
    .then((response) => response.data);
}

export function isTerminalReferralSourceImportStatus(status: ReferralSourceImportStatus): boolean {
  return status === 'completed' || status === 'error';
}
